<div class="app-page" style="margin: auto; padding: 0; min-height: 400px; font-family: Rubik, Verdana, sans-serif;">
  <mat-toolbar>
    <button mat-icon-button (click)="openSetGameFilterDialog()">
      <mat-icon>filter_alt</mat-icon>
    </button>
    <button mat-raised-button (click)="getPastGames()">
      <mat-icon>event_repeat</mat-icon>
      {{ 'GAMES.PAST' | translate | uppercase }}
    </button>
    <button mat-raised-button (click)="getData()">
      <mat-icon>event</mat-icon>
      {{ 'GAMES.COMING' | translate | uppercase }}
    </button>
    <!-- Timezone Menu Button -->
    <button mat-button [matMenuTriggerFor]="timezoneMenu" aria-label="Select timezone">
      {{ timezoneText | uppercase }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #timezoneMenu="matMenu">
      <button mat-menu-item (click)="toggleTimezone('GameTimeUTC')">{{ 'TIMEZONE.MY_TIMEZONE' | translate | uppercase }}</button>
      <button mat-menu-item (click)="toggleTimezone('GameDate')">{{ 'TIMEZONE.LOCAL_TIMEZONES' | translate | uppercase }}</button>
    </mat-menu>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (_pageData.Games.length === 0 && !isLoading) {
    <div style="margin: 20px; text-align: center;">
      {{ 'GAMES.NOGAMESFOUND' | translate | uppercase }}
    </div>
  }
  @if (isLoading) {
    <div style="margin: 20px; text-align: center;">
      {{ 'GENERAL.LOADING' | translate | uppercase }}...
    </div>
  }

  @if (_pageData && _pageData.Games.length > 0) {
    <div class="content-container">
      @for (group of _pageData.Games | groupByDateAndDivision: GroupByPropertyName : useLocalTimezone: sort; track group.GroupDate) {
        <!-- Date Divider -->
        <div class="date-divider">
          <div class="date-text">
            {{ group.GroupDate | date: 'dd' }} {{ group.GroupDate | date: 'MMM' }}
            <br>
              <span class="day-text">{{ group.GroupDate | date: 'EEE' }}</span>
            </div>
          </div>
          <!-- Divisioner -->
          @for (division of group.Divisions; track division.DivisionName) {
            <!-- Division Header -->
            <div class="division-header">
              {{ division.DivisionName }}
            </div>
            <!-- Games Table -->
            <mat-table [dataSource]="division.Games" class="mat-elevation-z2">
              <ng-container matColumnDef="matchDetails">
                <mat-cell *matCellDef="let game" class="game-row">
                  <!-- Left: Game Time -->
                  <div class="game-time-section">
                    <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)" class="game-link">
                      <div class="game-time">
                        {{ (GroupByPropertyName === 'GameTimeUTC' ? game.GameTimeUTC : game.GameTime) | date: 'HH:mm' }}
                      </div>
                      <div class="game-date">
                        {{ game.GameDate | date: 'MMM dd' }}
                      </div>
                    </a>
                  </div>

                  <!-- Middle: Team Data -->
                  <div class="teams-section">
                    <!-- Home Team -->
                    <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)" class="game-link">
                      <div class="team-row">
                        <img [src]="game.HomeTeamSmallIcon ? getIconPath(game.HomeTeamSmallIcon) : '/assets/images/placeholder.png'"
                          class="team-logo"
                          (error)="handleImageError($event)"
                          alt="Home Team Icon">
                        <div class="team-name">{{ game.HomeTeamName || 'No Home Team' }}</div>
                      </div>
                    </a>
                    <!-- Away Team -->
                    <a [routerLink]="['/scouting/gamedetails', game.GameId]" (click)="changeBgColor(game.GameId)" class="game-link">
                      <div class="team-row">
                        <img [src]="game.AwayTeamSmallIcon ? getIconPath(game.AwayTeamSmallIcon) : '/assets/images/placeholder.png'"
                          class="team-logo"
                          (error)="handleImageError($event)"
                          alt="Away Team Icon">
                        <div class="team-name">{{ game.AwayTeamName || 'No Away Team' }}</div>
                      </div>
                    </a>
                  </div>

                  <!-- Right: Add to Schedule Button -->
                  <div class="schedule-button-section">
                    <button mat-icon-button (click)="addToSchedule(game.GameId, game.HomeTeamName, game.AwayTeamName, game.GameDate, game.GameTime)"
                      class="action-button">
                      <mat-icon fontIcon="calendar_add_on" fontSet="material-icons-outlined"></mat-icon>
                      <span class="material-symbols-outlined">
                        calendar_add_on
                      </span>
                    </button>
                  </div>
                </mat-cell>
              </ng-container>
                  <mat-row *matRowDef="let row; columns: ['matchDetails']"
                    [ngClass]="{'past-game': pastGamesActive, 'coming-game': !pastGamesActive}"
                  style="border-left: 4px solid #2196f3; height: 56px;"></mat-row>
                </mat-table>
              }
            }
          </div>
        }
      </div>